import React, { useContext, useEffect, useState } from "react";
import { isVideoFile } from "../../helpers/Utils";
import { BuyGiftCardSubpageEnum } from "../../models/enums/BuyGiftCardSubpageEnum";
import { AppSettingContext } from "../Application";

type BuyGiftCardMailTemplateProps = {
    subpage: BuyGiftCardSubpageEnum;
    personalMessage: string;
    mediaUrl: string;
}

const BuyGiftCardMailTemplate = (props: BuyGiftCardMailTemplateProps) => {
    const { labels } = useContext(AppSettingContext);

    //#region STATE PROPERTIES

    const [personalMessage, setPersonalMessage] = useState(labels.get("GiftCard.App.Steps.Customise.PersonalMessage.DefaultText"));

    //#endregion

    //#region USE EFFECT HOOKS

    useEffect(() => {
        setPersonalMessage(props.personalMessage);
    }, [props.personalMessage]);

    //#endregion

    //#region COMMON HELPERS

    const encodeHTML = (input: string): string => {
        return input.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    };

    //#endregion

    return (
        <div className={`OptionsCardCub review-pay-box`}>
            <div className="action-card">
                <h3>{labels.get("GiftCard.App.V2.Sidebar.Mail.Title")}</h3>
                <div className="oc-box">
                    <h5>{labels.get("GiftCard.App.V2.Sidebar.Mail.Subtitle")}</h5>
                    <p
                        className="text small-fs text-wrap"
                        style={{ wordWrap: "break-word" }}
                        dangerouslySetInnerHTML={{ __html: encodeHTML(personalMessage) }}
                    ></p>

                    {props.mediaUrl.trim() && (
                        <div className="unwrap-gift" style={{ padding: '18px' }}>
                            <div className="unwrap-gift--box" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                {isVideoFile(props.mediaUrl) ? (
                                    <video
                                        controls
                                        src={props.mediaUrl}
                                        style={{ width: '100%' }}
                                    ></video>
                                ) : (
                                    <img
                                        style={{ width: '100%' }}
                                        src={props.mediaUrl}
                                        alt="mail template img"
                                    />
                                )}
                            </div>
                        </div>
                    )}

                    <h6>{labels.get("GiftCard.App.V2.Sidebar.Mail.FooterText")}</h6>
                </div>
            </div>
        </div>
    );
};

export default BuyGiftCardMailTemplate;